import React, { useState } from 'react'
import {useSelector, useDispatch} from 'react-redux'
import useSWR, {mutate} from 'swr'
import {withRouter} from 'react-router-dom'
import endpointSlice from '../../store/slices/endpoint'
import { Button, Icon, Header, Input, Grid, Table, Pagination } from 'semantic-ui-react'
import styles from './styles.module.scss'
import Loader from "../loader"
import {Message} from '../error'
import {AddDataContent, AddDialog} from "./dialogs"
import {AppFetcher} from "../../fetch/application"
import SidebarPanel from "../endpoint/SidebarPanel"
import {statusOptions, fieldNames} from './options'


function Endpoint({ history, match }) {

    const dispatch = useDispatch()
    const {dialogVisible} = useSelector(state => state.endpoints)

    const handleDialogVisibility = (content, isEdit) => {
        dialogVisible && setEditDialog(isEdit)
        dispatch(endpointSlice.actions.setDialogVisibility(!dialogVisible))
    }

    const [content, setContent] = useState(null)
    const toggleDialog = (e) => {
        if(dialogOpen) {
            setContent(null)
        }
        else {
            e && e.id && setContent(e)
        }
        setDialogOpen(!dialogOpen)
    }

    const [dialogOpen, setDialogOpen] = useState(false)
    const [shouldFetchDetail, setShouldFetchDetail] = useState(false)
    const [editDialog, setEditDialog] = useState(false)
    const [sidebarEndpoint, setSidebarEndpoint] = useState(null)
    const [sidebarVisible, setSidebarVisible] = useState(false)

    const editSidebar = () => {
        handleDialogVisibility(true);
        setEditDialog(true);
    }

    const closeSidebar = () => {
        setSidebarVisible(false)
        history.push(`/endpoint/`)
    }

    const toggleSidebar = endpoint => {

        if(sidebarVisible && endpoint.id === sidebarEndpoint.id) {
            setSidebarVisible(false)
            setSidebarEndpoint(null)
            history.push(`/endpoint/`)
        }
        else {
            setShouldFetchDetail(true)
            setSidebarVisible(true)
            setSidebarEndpoint(endpoint)
            history.push(`/endpoint/${endpoint.id}`)
        }
    }

    const handleSave = data => {
        const tmpA = sidebarEndpoint;
        setSidebarEndpoint(null);
        dialogOpen && toggleDialog()
        setSidebarEndpoint(tmpA);
        setShouldFetchDetail(true);
    }

    const [searchTerm, setSearchTerm] = useState("");
    history.listen(location => {
        setSearchTerm("");
    });
    let urlPart = "/endpoint/list";
    if (searchTerm) {
        urlPart += "/filter/" + searchTerm
    }

    const handleSearch = (e, {value}) => {
        setSearchTerm(value)
    }

    const onSubmitEndpoint = (id) => {
        setShouldFetchDetail(true);
        mutate('/endpoint/list')
        mutate(`/endpoint/details/${match.params.id}`)
    }

    const { data: list, error } = useSWR(`${urlPart}`, AppFetcher, {errorRetryCount: 2})
    const { data: detail, errorDetail } = useSWR((sidebarVisible && shouldFetchDetail) ? `/endpoint/details/${match.params.id}` : null, AppFetcher, {errorRetryCount: 2})

    React.useEffect(() => {
        if (detail && detail.data && sidebarVisible) {
            setSidebarEndpoint(detail.data)
        }
    }, [sidebarVisible, detail])
    if (error) {
        const message = error.response
            ? error.response.data.statusMessage
            : 'Something went wrong'

        return (
            <div className={styles.content}>
                <Message negative header={message} />
            </div>
        )
    }

    const endpoints = list && list.data
        ? list.data/*.map( app => new ApplicationModel(app) )*/
        : []

    return (
        <div className={styles.content}>
            <Header size="huge">Endpoints</Header>
            <Button primary onClick={ handleDialogVisibility }>
                <Icon style={{marginRight: '15px !important'}} name="plus" />
                Create new
            </Button>

            <br /><br />

            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <Input
                            icon="search"
                            iconPosition="left"
                            placeholder="Search Endpoints"
                            onChange={handleSearch}
                        />
                    </Grid.Column>
                </Grid.Row>

                {!list && <Loader /> }

                <Table basic="very">

                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>{fieldNames.report_name}</Table.HeaderCell>
                            <Table.HeaderCell>{fieldNames.schedule_name}</Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    {list && <Table.Body>

                        { endpoints.map( endpoint => (
                            <Table.Row
                                className={styles.row}
                                key={`endpoint-${endpoint.id}`}
                                onClick={() =>  toggleSidebar(endpoint)/*handleOpenApp({id: app.id, name: app.name})*/}
                            >
                                <Table.Cell>
                                    {endpoint.report.name}
                                </Table.Cell>
                                <Table.Cell>
                                    {endpoint.schedule.name}
                                </Table.Cell>
                                <Table.Cell  style={{textTransform: "capitalize"}}>
                                    {endpoint.status}
                                </Table.Cell>
                            </Table.Row>
                        ))}
                        {(endpoints && endpoints.length < 1) && (
                            <Table.Row>
                                <Table.Cell width={3}>No data</Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>}
                </Table>
                <br/>
            </Grid>

            <AddDialog
                title={"Add new Endpoint"}
                open={dialogVisible}
                item={(editDialog && sidebarEndpoint) && sidebarEndpoint}
                onClose={handleDialogVisibility}
                onSubmit={onSubmitEndpoint}
            />

            {sidebarEndpoint && <SidebarPanel
                visible={sidebarVisible}
                item={sidebarEndpoint}
                close={closeSidebar}
                edit={editSidebar}
                handleDialogVisibility={toggleDialog}
            />}

            {sidebarEndpoint && dialogOpen && <AddDataContent
                title={"Add new"}
                open={dialogOpen}
                onClose={toggleDialog}
                onSubmit={handleSave}
                id={sidebarEndpoint && sidebarEndpoint.schedule.id}
                item={content ? content : null}
            />}

        </div>
    )
}

export default withRouter(Endpoint)